import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import JSONSchemaForm from "react-jsonschema-form";
import { JsonForms } from "@jsonforms/react";
import schema from "./schema.json";
import { jsonSchema } from "../../shared/schema";
import { ehrActions, patientActions } from "../../core/actions";
import { useDispatch, useSelector } from "react-redux";
import { ecg } from "../../shared/schema/ecg.json";
import { doctorActions } from "../../core/actions";
import { labActions } from "../../core/actions";
import { Snackbar, Alert, SnackbarContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import {
  List,
  ListItem,
  Paper,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Grid,
} from "@material-ui/core";
import {
  CFollowupNote,
  DFollowupNote,
  FASTING_SUGAR_TEST,
  HAEMOGLOBIN,
  SCHEMA_OBJ,
  testNames,
} from "../../shared/constants";
import Components from "..";
import { Box } from "@mui/material";
import { PRODUCT_PHARMACY_LOCATION } from "../../shared/constants";

import {
  MASTER_LOCATION_DATA_LOCATION_KEY
} from "../../core/constants/erpConstants";

//import { event } from "react-ga";
// import {handleInputChange } from "../../shared/constants";
import {
  VITAL_SIGNS,
  EPRESCRIPTION,
  DIAGNOSIS,
  KESSLERTEST,
  HEMATOLOGYREPORTCBCDLC,
  BLOODGLUCOSEPROFILE,
  MULTILABREPORTS,
} from "../../shared/constants";
// import { Select } from "@mui/material";
import Select, { createFilter } from "react-select";
import { memo } from "react";
// import {Form} from 'react-jsonschema-form';
import { onConvertSchematoJsonBloodSugarProfile } from "../../shared/schema/BloodSugarProfile";
import personDetailsService from "../../core/services/personDetailsService";
import { helperServices } from "../../shared/helper";

// import formJSON from "form-json";
function PatientSchema(props) {
  const dispatch = useDispatch();
  const [formschema, setFormschema] = useState(false);
  const [formTitle, setFormTitle] = useState();
  const [schemajson, setSchemajson] = useState();
  const [patientId, setPatientId] = useState();
  const [visitId, setVisitId] = useState();
  const [uiSchema, setuiSchema] = useState({});
  const [templateId, setTemplateId] = useState();
  const [icd10, setIcd10] = useState([]);
  const [productList, setProductList] = useState([]);
  const [productDetails, setProductDetails] = useState();
  const patientEhrid = useSelector((state) => state.patientDetailsState.ehrid);
  const [presData, setPresData] = useState([]);

  // const [selectedOption, setSelectedOption] = useState();
  // const [selectedProduct, setSelectedProduct] = useState(null);
  // const [productBrand, setProductBrand] = useState('');
  const [selectProcedureTemplateId, setSelectProcedureTemplateId] = useState();
  const [eprescription, seteprescription] = useState();
  // const[prescriptionValue,setPrescriptionValue]=useState({
  //   localMedicalBrand: '',
  //   instructionstoPatient: '',
  //   advicetoDispenser: '',
  //   comments: ''
  // });

  // const MemoizedExternalModule = memo(JSONSchemaForm);

  const masterLocationDetails = useSelector(
    (state) => state.erpDetailsState.masterLocationDetails
  );

  const modifyNotes = {
    localMedicalBrand: "",
    instructionstoPatient: "",
    advicetoDispenser: "",
    comments: "",
    problemDiagnosis: "",
    dose: "",
  };
  const procedure = {
    id: "",
    gvid: "",
    patientId: "",
    visitId: "",
    longdesc: "",
    groupname: "",
  };

  const modifyVitalNotes = {};

  let saveFormData = {};
  const [compositionPreviewValue, setCompositionPreviewValue] = useState({
    brandName: "",
    icdName: "",
  });

  // const[icd10Name,setIcd10Name]=useState(
  //   {
  //     icdName:' ',
  //   }
  // );

  // const newIcd10Name = {
  //   ...icd10Name,
  //   icdName:' ',
  // };

  // const { schema, uischema, formData } = props;

  // const memoizedForm = useMemo(() => {
  //   return <Form schema={schema} uiSchema={uischema} formData={formData} />;
  // }, [schema, uiSchema, formData]);

  const procedureSchema = useSelector(
    (state) => state.doctorDetailsState.compositions
  );

  const [filteredIcd10, setFilterdIcd10] = useState();
  const [selectedIcdDescription, setSelectedIcdDescription] = useState();
  const [doctorNotes, setDoctorNotes] = useState();
  const [counsellorNotes, setCounsellorNotes] = useState();
  const [showError, setShowError] = useState(false);
  const [formErrors, setFormErrors] = useState({
    name: "",
  });

  const [doctorList, setdoctorList] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState("");
  const [selectedDoctorList, setSelectedDoctorList] = useState([]);
  const [newformData, setNewFormData] = useState({});
  const formContext = useMemo(() => ({ datas: newformData }), [newformData]);
  const [open, setOpen] = useState(false);
  const [validate, setValidate] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [sampleDateTime, setSampleDateTime] = useState("");
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  let testNames = [];
  // const testNamesRef = useRef([]);
  let userName = null;
  const onError = (errors) => {
    // Handle errors here
    console.error("Form errors:", errors);
    // Display error messages to the user, etc.
  };
  const validateDiagnosis = (formData) => {
    console.log("formdata: ", formData);
    if (formData) {
      const allFieldsEmpty = Object.values(formData).every((value) => !value);

      if (allFieldsEmpty) {
        console.log("All fields in the form are empty!");
        return false;
      } else {
        console.log("At least one field in the form is filled.");
        return true;
      }
    } else {
      console.log("Form data is empty!");
      return false;
    }
  };

  const validateLabReport = (formData) => {
    console.log("formdata: ", formData);
    if (formData) {
      const allFieldsEmpty = Object.values(formData)
        .filter(
          (test) =>
            typeof test === "object" && test.hasOwnProperty("Analyte result")
        )
        .every((test) => !test["Analyte result"]);
      if (allFieldsEmpty) {
        console.log("All fields in the form are empty!");
        return false;
      } else {
        console.log("At least one field in the form is filled.");
        return true;
      }
    } else {
      console.log("Form data is empty!");
      return false;
    }
  };

  const validateField = (fieldName) => {
    let fieldValidationErrors = formErrors;
    if (fieldName == null) {
      if (props.templateData == EPRESCRIPTION) {
        fieldValidationErrors.name = "Please select the Medicine Brand Name";
      } else if (props.templateData == DIAGNOSIS) {
        fieldValidationErrors.name =
          "Please select the Problem/diaognosis Name";
      }
    }
    setFormErrors({ ...fieldValidationErrors });
  };

  const [dFollowup, setDFollowup] = useState("");
  const [cFollowup, setCFollowup] = useState("");
  const [id, setId] = useState("");

  // const MemoizedExternalModule = memo(JSONSchemaForm);

  //  const memoizedFormSchema = useMemo(() => {
  //   if (formschema === null) {
  //     return null;
  //   }
  //   return jsonSchema.getSchemaFromCanonicalJson(
  //     formschema.resCb,
  //     formschema.props?.templateData,
  //     formschema.props?.flags,
  //     formschema.icd10
  //   );
  // }, [formschema,props,icd10]);

  useEffect(() => {
    if (props.flags === "editComposition" && props.selectedTests) {
      const list = props.selectedTests.split(",").map((s) => s.trim());
      dispatch(
        labActions.getTestnames(list, (res) => {
          testNames = res;
        })
      );
    }
  }, [props.selectedTests]);

  useEffect(() => {
    console.log("props ::: ", props);
    // const MemoizedExternalModule = memo(JSONSchemaForm);
    getDoctorsList();
    const Form = JSONSchemaForm.default;
    var obj1 = {
      Diastolic: {
        type: "string",
        title: "Diastolic..",
        default: "A new task",
      },
    };
    var obj2 = {
      Sistolic: { type: "string", title: "Sistolic...", default: "A new task" },
    };
    console.log("Mode is : ", props.flags, props.templateData);
    if (props.mode == "edit")
      if (
        props.templateData == DFollowupNote ||
        props.templateData == CFollowupNote
      ) {
        setuiSchema();
        setFormschema();
        console.log("Mode is : ", props.flags);
        getFollowupNotes(
          props.selectedProcedure.patientId,
          props.selectedProcedure.visitId,
          props.templateData
        );
      }

    if (props.mode == "new")
      if (
        props.templateData == DFollowupNote ||
        props.templateData == CFollowupNote
      ) {
        setuiSchema();
        setFormschema();
        console.log("Mode is : ", props.flags);
        getFollowupNotes(
          props.patientInfo.id,
          props.patientInfo.visit.id,
          props.templateData
        );
      }
    var obj3 = Object.assign({}, obj1, obj2);
    console.log("procedureSchema :", procedureSchema);
    console.log("finalResult", obj3);
    console.log("props:", props);
    let patientId;
    let visitId;
    // console.log("tepmlateId",props.templateData);
    setTemplateId(props.templateData);
    for (let ids of props.patientData) {
      console.log("ids:", ids);
      patientId = ids.patientId;
      visitId = ids.visitId;
      setPatientId(patientId);
      setVisitId(visitId);
    }
    if (props.mode == "edit")
      if (props.selectedProcedure.subgroup == "Lab_Report") {
        setTemplateId(props.selectedProcedure.templateId);
        setPatientId(props.selectedProcedure.patientId);
        setVisitId(props.selectedProcedure.visitId);
      }
    if (props.flags == "editComposition") {
      console.log("templateData :", props.templateData);
      setSampleDateTime(props.selectedProcedure.billDate);
      let data = {};
      let ptehrId = patientEhrid ?? props.patientInfo?.ehrid ?? null;

      // ✅ Non-EHR org — no ehrId, parse notes JSON directly
      if (!ptehrId || ptehrId === "") {
        console.log("Non-EHR org: using notes JSON from procedure");
        (async () => {
          try {
            const notesJson = JSON.parse(props.selectedProcedure.notes);
            const templateForUi = props.selectedProcedure.templateId;

            if (templateForUi === "ePrescription (epSoS/Contsys)") {
              let val = notesJson.content[0].activities[0].description.items;
              setPresData(val);
            }

            let notes = props.selectedProcedure.notes ?? "";
            if (notes.endsWith(" Report")) {
              notes = notes.replace(/ Report$/, "");
            }

            let form = await jsonSchema.getSchemaFromCanonicalJson(
              notesJson,
              templateForUi,
              props.flags,
              compositionPreviewValue,
              icd10,
              notes,
              testNames
            );
            setFormschema(form);
            setSchemajson(notesJson);
            setSelectProcedureTemplateId(templateForUi);
            formUiSchema(templateForUi, false);

            let frm = await jsonSchema.getSchemaFromCanonicalJson(
              notesJson,
              templateForUi,
              "editComposition"
            );
            seteprescription(frm);
          } catch (e) {
            console.error("Failed to parse notes JSON in PatientSchema", e);
          }
        })();   // ← closes (async () => {
        return; // ← outside the async block
      }         // ← closes if (!ptehrId)
      // EHR org — normal flow
      dispatch(
        ehrActions.getCompositionByVid(
          data,
          props.templateData,
          ptehrId,
          async (resCb) => {
            if (resCb) {
              let templateForUi;
              if (
                props.selectedProcedure.templateId ==
                resCb.archetype_details.template_id.value
              ) {
                templateForUi = resCb.archetype_details.template_id.value;
              } else {
                templateForUi = props.selectedProcedure.templateId;
              }
              if (templateForUi === "ePrescription (epSoS/Contsys)") {
                console.log("API Response :", resCb);
                console.log(
                  "data for prescription : ",
                  resCb.content[0].activities[0].description.items
                );
                let val = [];
                val = resCb.content[0].activities[0].description.items;
                setPresData(val);
              }
              console.log("resc :", templateForUi);
              let notes = props.selectedProcedure.notes ?? "";

              // remove trailing " Report" only if exists
              if (notes.endsWith(" Report")) {
                notes = notes.replace(/ Report$/, "");
              }
              // console.log("productBrand",productBrand.brandName);
              let form = await jsonSchema.getSchemaFromCanonicalJson(
                resCb,
                templateForUi,
                props.flags,
                compositionPreviewValue,
                icd10,
                notes,
                testNames
              );
              setCompositionPreviewValue(compositionPreviewValue);
              console.log(
                "form, compositionpreviewvalue: ",
                form,
                compositionPreviewValue
              );
              let frm = await jsonSchema.getSchemaFromCanonicalJson(
                resCb,
                templateForUi,
                "editComposition"
              );
              console.log("frm ::: ", frm);
              seteprescription(frm);
              // console.log("")
              // productBrand,
              //   icd10Name
              // setproductBrand(productBrand);
              // setIcd10Name(icd10Name);
              // console.log("seticd10Name",icd10Name);
              // console.log("seticd10Name",icd10Name.icdName);
              // console.log("setProductBrand",productBrand);
              // console.log("productBrand",productBrand.brandName);

              console.log("templateforui: ", templateForUi);
              console.log(
                "setSelectProcedureTemplateId",
                props.selectedProcedure.templateId
              );
              setSelectProcedureTemplateId(props.selectedProcedure.templateId);
              console.log("formrrr", form);
              // dispatch(patientActions.setForm(form));
              setFormschema(form);
              setSchemajson(resCb);
              const compositeService =
                props.selectedProcedure?.packageService?.compositeService?.replace(
                  /"/g,
                  ""
                ) || "";

              let firstService = templateForUi;
              const labMatch = compositeService.match(
                /lab\s*services\s*:(.*)/i
              );
              if (labMatch && labMatch[1]) {
                const labPart = labMatch[1].trim();
                const firstLabItem = labPart
                  .split(",")
                  .map((s) => s.trim())
                  .find((s) => s.length > 0);

                if (firstLabItem) {
                  firstService = firstLabItem;
                }
              }
              formUiSchema(firstService, false);
              console.log("formschema1", formschema, schemajson);
            }
          }
        )
      );
    } else {
      // let formschema = jsonSchema.getSchemaFromJson(schema)
      const procedure = props.selectedProcedure || {};
      const cleanedData = {
        ...procedure,
        combinedProcedures: procedure.combinedProcedures?.map((p) => ({
          id: p.id,
          patientId: p.patientId,
          visitId: p.visitId,
          gvid: p.gvid,
          notes: p.notes,
        })),
      };
      let data1 = {};

      dispatch(
        ehrActions.getTemplateById(
          cleanedData,
          props.templateData,
          props.patientInfo,
          async (resCb) => {
            if (resCb) {
              console.log("templateData : ", props.templateData);
              console.log("Diagnosis Master API Response:", resCb);
              console.log(
                "template data in gettemplate method:",
                props.templateData
              );
              if (props.templateData && props.templateData == DIAGNOSIS) {
                dispatch(
                  ehrActions.getIcd10Values(data1, async (resCb1) => {
                    if (resCb1) {
                      console.log("icd10 list is", resCb1.icd10List);
                      setIcd10([...resCb1.icd10List]);
                      let form = await jsonSchema.getSchemaFromCanonicalJson(
                        resCb,
                        props.templateData,
                        props.flags,
                        resCb1.icd10List
                      );
                      let frm = await jsonSchema.getSchemaFromCanonicalJson(
                        resCb,
                        props.templateData,
                        "editComposition"
                      );
                      console.log("frm ::: ", frm);
                      seteprescription(frm);
                      // setFormschema({
                      //   resCb: resCb,
                      //   props: props,
                      //   icd10: resCb1.icd10List,
                      // });
                      console.log("templateid: ", templateId);
                      console.log("form obtained:", form);
                      setFormschema(form);
                      setSchemajson(resCb);
                      formUiSchema(props.templateData, false);
                      console.log("formschema1", formschema);
                    }
                  })
                );
              } else if (
                props.templateData &&
                props.templateData == EPRESCRIPTION
              ) {
                let productsearch = "dol";
                const pharmacyLocationId = helperServices.getFirstLocationIdByKey(
                  masterLocationDetails,
                  MASTER_LOCATION_DATA_LOCATION_KEY.PHARMACY
                );

                dispatch(
                  doctorActions.getProductDetails(
                    productsearch,
                    pharmacyLocationId,
                    async (productResponse) => {
                      if (productResponse) {
                        console.log(
                          "Response of searched product",
                          productResponse.erpProductList
                        );
                        console.log("schema is ", resCb);
                        const form =
                          await jsonSchema.getSchemaFromCanonicalJson(
                            resCb,
                            props.templateData,
                            props.flags,
                            productDetails
                          );
                        let frm = await jsonSchema.getSchemaFromCanonicalJson(
                          resCb,
                          props.templateData,
                          "editComposition"
                        );
                        console.log("frm ::: ", frm);
                        seteprescription(frm);
                        console.log("form obtained:", form);
                        setFormschema(form);
                        setSchemajson(resCb);
                        formUiSchema(props.templateData, false);
                        console.log("formschema1", formschema);
                      }
                    }
                  )
                );
              } else {
                console.log("entered else condition");
                let form = await jsonSchema.getSchemaFromCanonicalJson(
                  resCb,
                  props.templateData,
                  props.flags
                );

                console.log("form obtained:", form);
                console.log("template data", props.templateData);

                if (
                  props.templateData == "Vital signs" &&
                  props.mode == "new"
                ) {
                  console.log("templatedata", props.templateData);
                  filterFormVitals(form);
                }

                setFormschema(form);
                setSchemajson(resCb);
                const compositeService =
                  props.selectedProcedure?.packageService?.compositeService?.replace(
                    /"/g,
                    ""
                  ) || "";

                let firstService = props.templateData;
                const labMatch = compositeService.match(
                  /lab\s*services\s*:(.*)/i
                );
                if (labMatch && labMatch[1]) {
                  const labPart = labMatch[1].trim();
                  const firstLabItem = labPart
                    .split(",")
                    .map((s) => s.trim())
                    .find((s) => s.length > 0);

                  if (firstLabItem) {
                    firstService = firstLabItem;
                  }
                }
                formUiSchema(firstService, false);
                console.log("formschema1", formschema);
              }
            }
          }
        )
      );

      const filterFormVitals = (form) => {
        console.log("filterformvitals");
        console.log("form: ", form);

        for (let property in form.properties) {
          if (
            form.properties.hasOwnProperty(property) &&
            property === "Body mass index"
          ) {
            console.log("body mass", property);
            delete form.properties[property];
          }
        }
        console.log("form after deletion of bmi: ", form);
      };

      //     }
      // }))
      // let formschema = jsonSchema.getSchemaFromCanonicalJson(tem)
      // let formschema = jsonSchema.getSchemaFromPrescJson(schema)
      // let formschema = jsonSchema.getSchemaFromDiagnoJson(schema)

      // console.log("formschema2", formschema);
      // if (!memoizedFormSchema) {
      //   return null;
      // }

      // setFormschema(formschema)
    }
  }, [props]);

  function formatDateTimeLocal(dateString) {
    if (!dateString) return "";

    const date = new Date(dateString);
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - offset * 60 * 1000);

    return localDate.toISOString().slice(0, 16); // "YYYY-MM-DDTHH:MM"
  }

  const getFollowupNotes = (pid, vid, temp) => {
    dispatch(
      doctorActions.getFollowupNotes(pid, vid, temp, (resCb) => {
        if (resCb) {
          console.log("resCb doctor Response:", resCb);
          console.log("resCbe : ", resCb);
          // patientDetail['scheduleddate'] = resCb.scheduleddate;
          if (temp == DFollowupNote) {
            setDFollowup(resCb.procedure.notes);
          } else {
            setCFollowup(resCb.procedure.notes);
          }
          console.log("followup note is : ", dFollowup, cFollowup);
          setId(resCb.procedure.id);
        }
      })
    );
  };

  const formUiSchema = (templateId, readOnly) => {
    // console.log("DIAGNOSIS_OBJ:", SCHEMA_OBJ);
    console.log("props: ", props);

    const schema_obj = SCHEMA_OBJ();
    console.log("schema_obj: ", schema_obj);

    Object.keys(schema_obj).forEach((key) => {
      console.log("key, templateid: ", templateId, key);

      if (key == templateId) {
        let schema = schema_obj[key];
        console.log("schema", schema);
        //console.log("enteredthis")
        Object.keys(schema).forEach((key) => {
          schema[key]["ui:readonly"] = readOnly;
        });
        console.log("filterd:", schema);
        setuiSchema({ ...schema });
        console.log("ui schema fromed:", uiSchema);
        setuiSchema({ ...schema });
        console.log("ui schema fromed:", uiSchema);
      }
    });
  };

  // const formUiSchema = (templateId, readOnly) => {
  //   // console.log("DIAGNOSIS_OBJ:", SCHEMA_OBJ);
  //   console.log("props: ", props);

  //   // const schema_obj  = SCHEMA_OBJ
  //   // console.log("schema_obj: ", schema_obj);

  //   Object.keys(SCHEMA_OBJ).forEach((key) => {
  //     console.log("key, templateid: ", templateId, key);

  //     if (key == templateId) {
  //       let schema = SCHEMA_OBJ[key];
  //       console.log("schema", schema);
  //       //console.log("enteredthis")
  //       Object.keys(schema).forEach((key) => {
  //         schema[key]["ui:readonly"] = readOnly
  //       });
  //       console.log("filterd:", schema);
  //       setuiSchema({ ...schema });
  //       console.log("ui schema fromed:", uiSchema);
  //       setuiSchema({ ...schema });
  //       console.log("ui schema fromed:", uiSchema);

  //     }
  //   });
  // };

  const onFormSubmit = (event) => {
    console.log("onFormSubmitevents", event);
    //console.log("jsonschemasss",jsonSchema)
    console.log("---Form Submited---", event.formData);
    // schema.archetype_details.template_id.value
    // schemajson
    if (schemajson.archetype_details.template_id.value === KESSLERTEST) {
      onConvertSchematoJsonkesslers(event.formData);
    } else if (
      schemajson.archetype_details.template_id.value === EPRESCRIPTION
    ) {
      validateField(productDetails);
      if (formErrors.name == "") {
        console.log("Converting schema to ePrescription format");
        // console.log("formErrors.name",formErrors.name);
        onConvertSchematoJsonprescription(event.formData);
        // event.formData['Local medicinal product brand']=productDetails;
      }
    } else if (schemajson.archetype_details.template_id.value === DIAGNOSIS) {
      // validateField(selectedIcdDescription);
      // if (formErrors.name == "") {
      if (!validateDiagnosis(event.formData)) {
        setShowError(true);
        return;
      } else {
        setShowError(false);
        onConvertSchematoJsonDiagnosis(event.formData);
      }
      // }
    } else if (schemajson.archetype_details.template_id.value === VITAL_SIGNS) {
      if (!validateDiagnosis(event.formData)) {
        setShowError(true);
        return;
      } else {
        setShowError(false);
        onConvertSchematoJsonVitals(event.formData);
      }
    } else if (schemajson.archetype_details.template_id.value === "k_problem") {
      onConvertSchematoJsonk_problems(event.formData);
    } else if (
      schemajson.archetype_details.template_id.value === BLOODGLUCOSEPROFILE
    ) {
      console.log("imhere");
      onConvertSchematoJsonBloodSugarProfile(event.formData);
    } else if (
      schemajson.archetype_details.template_id.value === "Laboratory Report"
    ) {
      console.log("hehhe");
      onConvertSchematoJsonLabReports(event.formData);
    } else if (
      schemajson.archetype_details.template_id.value === MULTILABREPORTS
    ) {
      if (!validateLabReport(event.formData)) {
        setShowError(true);
        return;
      } else {
        setShowError(false);
        console.log("hehhe");
        onConvertSchematoJsoMultinLabReports(event.formData);
        if (props.selectedProcedure?.combinedProcedures?.length > 0) {
          props.selectedProcedure.combinedProcedures.forEach((proc) => {
            if (!proc.subgroup?.includes("Lab_Report")) {
              const procedure = {
                id: proc.id,
                gvid: proc.gvid || props.selectedProcedure?.gvid,
                patientId: proc.patientId || props.selectedProcedure?.patientId,
                visitId: proc.visitId || props.selectedProcedure?.visitId,
                shortdesc: "Report Submitted",
                groupname: "Lab_Report",
              };
              editProcedure(procedure);
            }
          });
        } else {
          if (!props.selectedProcedure.subgroup?.includes("Lab_Report")) {
            const procedure = {
              id: props.selectedProcedure?.id,
              gvid: props.selectedProcedure?.gvid,
              patientId: props.selectedProcedure?.patientId,
              visitId: props.selectedProcedure?.visitId,
              shortdesc: "Report Submitted",
              groupname: "Lab_Report",
            };
            editProcedure(procedure);
          }
        }
      }
    }
  };

  const onChanges = (formData, newErrorSchema) => {
    console.log("Onchanges fired");
    console.log("formonchanges", formData.formData);

    saveFormData = formData.formData;
    setNewFormData(saveFormData);
    console.log("saveformdata: ", saveFormData);
  };

  // const memoizedValue = useMemo(() => onChanges(), []);
  console.log(",saveFormDatasaveFormData", saveFormData);

  const saveAndAddNewSubmit = () => {
    let data = "";
    let productsearch = "dol";
    console.log("---saveAndAddNewSubmitForm---", saveFormData);
    if (schemajson.archetype_details.template_id.value === KESSLERTEST) {
      onConvertSchematoJsonkesslers(saveFormData);
    } else if (
      schemajson.archetype_details.template_id.value === EPRESCRIPTION
    ) {
      validateField(productDetails);
      if (formErrors.name == "") {
        console.log("Converting schema to ePrescription format");
        // console.log("formErrors.name",formErrors.name);
        onConvertSchematoJsonprescription(saveFormData, "add new");
        dispatch(
          ehrActions.getTemplateById(
            data,
            props.templateData,
            props.patientInfo,
            (resCb) => {
              if (resCb) {
                console.log("Diagnosis Master API Response:", resCb);
                console.log(
                  "template data in gettemplate method:",
                  props.templateData
                );
                dispatch(
                  doctorActions.getProductDetails(
                    productsearch,
                    PRODUCT_PHARMACY_LOCATION,
                    async (productResponse) => {
                      if (productResponse) {
                        console.log(
                          "Response of searched product",
                          productResponse.erpProductList
                        );
                        console.log("schema is ", resCb);
                        let form = await jsonSchema.getSchemaFromCanonicalJson(
                          resCb,
                          props.templateData,
                          props.flags,
                          productDetails
                        );
                        console.log("form obtained:", form);
                        setFormschema(form);
                        setSchemajson(resCb);
                        formUiSchema(props.templateData, false);
                        console.log("formschema1", formschema);
                      }
                    }
                  )
                );
              }
            }
          )
        );
      }
      setProductDetails("");
    } else if (schemajson.archetype_details.template_id.value === DIAGNOSIS) {
      validateField(selectedIcdDescription);
      if (formErrors.name == "") {
        onConvertSchematoJsonDiagnosis(saveFormData);
      }
    } else if (schemajson.archetype_details.template_id.value === VITAL_SIGNS) {
      onConvertSchematoJsonVitals(saveFormData);
    }
  };

  const onConvertSchematoJsonDiagnosis = (data) => {
    console.log("jsonconvert:", data);

    console.log("schemajson:", schemajson);
    for (let content of schemajson.content) {
      console.log("content : ", content);
      for (let items of content.data.items) {
        console.log("items : ", items);
        if (items.name && items.name.value) {
          if (items.name.value == "Problem/Diagnosis name") {
            // modifyElement(items.name.value,selectedIcdDescription);
            // items.value.value=selectedIcdDescription;
            // data[items.name.value] = selectedIcdDescription;
            console.log("data[items.name.value]", data[items.name.value]);
            items.value.value = "Diagnosis";
            console.log(
              "modifyNotes.problemDiagnosis",
              modifyNotes.problemDiagnosis
            );
          } else if (items.name.value == "Clinical description") {
            items.value.value = data[items.name.value]
              ? data[items.name.value]
              : "NA";
            console.log("Diagnosis", items.value.value);
            modifyNotes.problemDiagnosis = items.value.value;
            console.log(
              "modifyNotes.problemDiagnosis",
              modifyNotes.problemDiagnosis
            );
          } else {
            console.log("log2:", data[items.name.value]);
            // items.value.value = data[items.name.value];
            items.value.value = data[items.name.value]
              ? data[items.name.value]
              : "NA";
          }
        } else {
          console.log("Unable to access item name or value");
        }
      }
    }
    onFormChange(schemajson);
  };

  const [bmipara, setbmipara] = useState({
    weight: "",
    height: "",
  });

  const onConvertSchematoJsonVitals = (data) => {
    console.log("jsonconvert:", data);

    if (data.hasOwnProperty("Height/Length")) {
      console.log("data height: ", data["Height/Length"]);
      bmipara.height =
        data["Height/Length"] >= 100 && data["Height/Length"] != undefined
          ? data["Height/Length"]
          : 100;
    } else {
      bmipara.height = 100;
    }

    if (data.hasOwnProperty("Weight")) {
      console.log("data Weight: ", data["Weight"]);
      bmipara.weight =
        data["Weight"] >= 1 && data["Weight"] != undefined
          ? data["Weight"]
          : 100;
    } else {
      bmipara.weight = 100;
    }

    // for (let entry in data) {
    //   if (entry === "Height/Length") {
    //     console.log("data[entry]: ", data[entry])
    //     bmipara.height = data[entry] ? data[entry]:150 ;
    //     console.log(bmipara);
    //   }
    //   if (entry === "Weight") {
    //     bmipara.weight = data[entry]? data[entry]:60;
    //     console.log(bmipara);

    //   }
    //   else

    console.log(bmipara);

    console.log("schemajson:", schemajson);
    for (let content of schemajson.content) {
      console.log("content : ", content);
      for (let item of content.data.events) {
        for (let it of item.data.items) {
          console.log("it :", it);
          let elementName1 = it.name.value;
          console.log("elementName1 :", elementName1);
          // console.log("daya : ", data[elementName1]);
          // it.value.magnitude = data[elementName1];
          switch (elementName1) {
            case "Temperature":
              data[elementName1] = data[elementName1] ? data[elementName1] : 97;
              console.log("Temperature", data[elementName1]);
              const celsius = parseFloat(data[elementName1]);
              const fahrenheit = convertToFahrenheit(celsius);
              console.log(
                "Temperature in Fahrenheit::",
                ` ${fahrenheit.toFixed(2)}`
              );
              data[elementName1] = fahrenheit.toFixed(2);
              it.value.magnitude = data[elementName1];
              modifyVitalNotes[elementName1] = it.value.magnitude;
              break;

            case "Systolic":

            case "Diastolic":

            case "Pulse Rate":

            case "Height/Length":

            case "Weight":

            case "Respiratory Rate":
              data[elementName1] = data[elementName1] ? data[elementName1] : 0;
              console.log("value:", data[elementName1]);
              it.value.magnitude = data[elementName1];
              modifyVitalNotes[elementName1] = it.value.magnitude;

              break;

            case "Oxygen Saturation Level (SpO₂)":
              data[elementName1] = data[elementName1] ? data[elementName1] : 0;
              console.log("value", data[elementName1]);
              it.value.numerator = data[elementName1];
              modifyVitalNotes[elementName1] = it.value.numerator;
              break;

            case "Body mass index":
              //data[elementName1]=data[elementName1]?data[elementName1]:17;
              //console.log(calculateBmi(bmipara))
              const bmi = calculateBmi(bmipara);
              console.log("bmi", bmi);
              data[elementName1] = bmi;
              it.value.magnitude = data[elementName1];
              modifyVitalNotes[elementName1] = it.value.magnitude;
              break;

            // other cases
          }
        }
      }
    }
    onFormChange(schemajson);
  };

  function convertToFahrenheit(fahrenheit) {
    const celsius = ((fahrenheit - 32) * 5) / 9;
    return celsius;
  }

  function calculateBmi(bmipara) {
    const height = parseFloat(bmipara.height) / 100;
    const weight = parseFloat(bmipara.weight);
    const bmi = (weight / (height * height)).toFixed(1);
    console.log(height, weight, bmi);
    return bmi;
  }

  const onConvertSchematoJsonk_problems = (data) => {
    console.log("jsonconvert:", data);
    console.log("schemajson:", schemajson);
    for (let content of schemajson.content) {
      console.log("content : ", content);
      for (let item of content.data.events) {
        //  console.log('item:',item)
        for (let it of item.data.items) {
          console.log("it :", it);
          let elementName1 = it.name.value;
          console.log("elementName1 :", elementName1);
          console.log("values :", data[elementName1]);
          // it.value.magnitude = data[elementName1];
        }
      }
    }
    onFormChange(schemajson);
  };

  const onConvertSchematoJsonkesslers = (data) => {
    console.log("jsonconvert:", data);
    console.log("schemajson:", schemajson);
    for (let content of schemajson.content) {
      console.log("content : ", content.data);
      for (let events of content.data.events) {
        console.log("events :", events);
        for (let items of events.data.items) {
          console.log("items:", items);
          items.value.value = data[items.name.value].split("-")[0];
          items.name.value = data[items.name.value].split("-")[1];
          console.log("items:", items);
          console.log("schemajson:", schemajson);
          setSchemajson(schemajson);
        }
      }
    }
    onFormChange(schemajson);
  };

  const onConvertSchematoJsonFastingBloodSugar = (data) => {
    console.log("jsonconvert:", data);
    console.log("schemajson:", schemajson);
    for (let content of schemajson.content) {
      console.log("content : ", content.data);
      for (let events of content.data.events) {
        console.log("events :", events);
        for (let items of events.data.items) {
          console.log("items:", items);
          // items.value.value = data[items.name.value].split("-")[0];
          // items.name.value = data[items.name.value].split("-")[1];
          console.log("items:", items);
          console.log("schemajson:", schemajson);
          setSchemajson(schemajson);
        }
      }
    }
    onFormChange(schemajson);
  };

  const onConvertSchematoJsonBloodSugarProfile = (data) => {
    let elements;
    let elementName1, elementName2;
    console.log("data:", data);
    console.log("jsonconvert:", data);
    console.log("schemajson:", schemajson);

    for (let content of schemajson.content) {
      console.log("content : ", content.data);
      for (let events of content.data.events) {
        console.log("events :", events);
        for (let items of events.data.items) {
          console.log("items:", items);
          elements = items.name.value;
          console.log("element: ", elements);
          switch (elements) {
            case "Test":
              elementName1 = items.value.value;
              console.log("elementName1: ", elementName1);
              break;

            case "Result Group":
              for (let i of items.items) {
                console.log("i: ", i);
                elementName2 = i.name.value;
                console.log("elementName2: ", elementName2);
                console.log("value:", data[elementName1][elementName2]);

                if (elementName2 === "Result") {
                  i.value.magnitude = data[elementName1][elementName2];
                } else if (elementName2 === "Comment") {
                  i.value.value = data[elementName1][elementName2];
                }
              }

              break;
          }
          console.log("schemajson:", schemajson);
        }
      }
    }
    onFormChange(schemajson);
  };

  const onConvertSchematoJsonLabReports = (data) => {
    let elements, testName;
    let elementName1, elementName2;
    console.log("data:", data);
    console.log("jsonconvert:", data);
    console.log("schemajson:", schemajson);

    for (let content of schemajson.content) {
      console.log("content : ", content.data);
      for (let events of content.data.events) {
        console.log("events :", events);
        for (let items of events.data.items) {
          console.log("items:", items);
          elements = items.name.value;
          console.log("element: ", elements);
          switch (elements) {
            case "Result Groups":
              for (let i of items.items) {
                console.log("i: ", i);
                elementName2 = i.name.value;
                console.log("elementName2: ", elementName2);
                //console.log("value:", data[elementName1][elementName2]);
                if (elementName2 === "Analyte Name") {
                  testName = i.value.value;
                  //console.log("testname: ",testName)
                  console.log("value: ", data[testName]);
                }
                if (elementName2 === "Result") {
                  i.value.magnitude = data[testName]["Result"];
                } else if (elementName2 === "Comment") {
                  i.value.value = data[testName]["Comment"];
                }
              }

              break;
          }
          console.log("schemajson:", schemajson);
        }
      }
    }
    onFormChange(schemajson);
  };

  const onConvertSchematoJsonprescription = (data, flag) => {
    console.log("jsonconvert:", data);
    // if(data["Instructions to patient"])
    console.log("schema :", schemajson);
    for (let content of schemajson.content) {
      for (let events of content.activities) {
        for (let items of events.description.items) {
          console.log("itms", items);
          if (items._type == "CLUSTER") {
            for (let item of items.items) {
              if (item._type === "CLUSTER") {
                for (let i of item.items) {
                  console.log("i: ", i);
                  let elementName1 = i.name.value;
                  i.value.value = data[elementName1];

                  modifyElement(elementName1, i.value.value);
                }
              } else {
                console.log("field", item.name.value, data[item.name.value]);
                modifyCluster(item.name.value, data[item.name.value]);
                item.value.value = data[item.name.value];
                console.log(
                  "data of advice to dispencer after",
                  item.name.value,
                  data[item.name.value]
                );
              }
            }
          }
          if (items._type == "ELEMENT") {
            console.log("element is", items._type);
            // console.log("items befoe", items.name.value,data[items.name.value])
            if (items.name.value == "Local medicinal product brand") {
              modifyElement(items.name.value, productDetails);
              data[items.name.value] = productDetails;
              items.value.value = productDetails;
            } else if (items.name.value == "Instructions to patient") {
              if (!data.hasOwnProperty("Instructions to patient")) {
                data["Instructions to patient"] = " ";
                items.value.value = data["Instructions to patient"];
                console.log("data: ", data);
              } else {
                items.value.value = data[items.value.value];
              }
            }
            modifyElement(items.name.value, data[items.name.value]);
            items.value.value = data[items.name.value];
            console.log("itemsafter", items.name.value, data[items.name.value]);
          }
        }
      }
    }
    console.log("onformchangeschemajson", schemajson);
    onFormChange(schemajson, flag);
  };

  const modifyCluster = (feildname, filedvalue) => {
    if (feildname == "Advice to dispenser") {
      modifyNotes.advicetoDispenser = filedvalue;
    }
  };

  const modifyElement = (feildname, filedvalue) => {
    console.log("feildname,filedvalue", feildname, filedvalue);
    if (feildname == "Local medicinal product brand") {
      modifyNotes.localMedicalBrand = filedvalue;
    } else if (feildname == "Instructions to patient") {
      if (filedvalue === null || filedvalue === "") {
        modifyNotes.instructionstoPatient = "";
      } else {
        modifyNotes.instructionstoPatient = filedvalue;
      }
    } else if (feildname == "Comment") {
      modifyNotes.comments = filedvalue;
    } else if (feildname == "Dose unit") {
      modifyNotes.dose = filedvalue;
    }
  };
  const onConvertSchematoJsonNewLabReports = (data) => {
    let elements, testName;
    let elementName1, elementName2;
    console.log("data:", data);
    console.log("jsonconvert:", data);
    console.log("schemajson:", schemajson);

    for (let content of schemajson.content) {
      console.log("content : ", content.data);
      for (let events of content.data.events) {
        console.log("events :", events);
        for (let items of events.data.items) {
          console.log("items:", items);
          elements = items.name.value;
          console.log("element: ", elements);
          switch (elements) {
            case "Test":
              for (let i of events.data.items) {
                elementName2 = i.name.value;
                if (elementName2 === "Test") {
                  testName = i.value.value;
                }
                console.log("i: ", i);
                console.log("elementName2: ", elementName2);
                if (elementName2 === "Result") {
                  i.value.value = data[testName]["Result"];
                }
              }
              break;
          }
          console.log("schemajson:", schemajson);
        }
      }
    }
    onFormChange(schemajson);
  };

  const onConvertSchematoJsoMultinLabReports = (data) => {
    console.log("role", userName);

    for (let content of schemajson.content) {
      for (let events of content.data.events) {
        events.data.items = events.data.items.filter((item) => {
          if (item._type === "ELEMENT" && item.name.value !== "COMMENT") {
            const elementValue = item.value.value;
            return data[elementValue] !== undefined;
          }

          if (item.name.value === "COMMENT") {
            item.value = {
              _type: "DV_TEXT",
              value: data["COMMENT"] ?? "",
            };
            return true;
          }

          if (item._type === "CLUSTER") {
            let analyteName = null;

            const analyteNameItem = item.items.find(
              (sub) => sub.name.value === "Analyte name"
            );

            analyteName = analyteNameItem?.value?.value;

            if (!analyteName || !data[analyteName]) {
              return false;
            }

            for (let subItem of item.items) {
              const name = subItem.name.value;

              if (name === "Analyte result") {
                const result = data[analyteName]?.["Analyte result"];
                const unit = data[analyteName]?.["Units"];

                if (result !== undefined && result !== "") {
                  if (!isNaN(parseFloat(result)) && isFinite(result)) {
                    if (!unit) {
                      subItem.value.value = result;
                      delete subItem.value.magnitude;
                    } else {
                      subItem.value.magnitude = result;
                      delete subItem.value.value;
                    }
                  } else {
                    subItem.value.value = unit
                      ? `${result},unit(${unit})`
                      : result;
                    delete subItem.value.magnitude;
                  }
                } else {
                  subItem.value.value = "";
                  delete subItem.value.magnitude;
                }
              }

              if (name === "Reference range guidance") {
                const refRange =
                  data[analyteName]?.["Reference range guidance"];
                subItem.value.value = refRange ?? "";
              }
            }
            return true;
          }
          return true;
        });
      }
    }
    onFormChange(schemajson);
  };

  const onFormChange = (data, flag) => {
    console.log("---Form changed---", data);
    console.log("---patientEhrid---", patientEhrid);

    // console.log("prescription value",prescriptionValue);
    // console.log("modifynotes",modifyNotes);
    // const  prescriptionDetails=modifyNotes.localMedicalBrand+' '+' '+modifyNotes.advicetoDispenser+' '+modifyNotes.instructionstoPatient;
    // const prescriptionDetails=modifyNotes.problemDiagnosis;
    let notesDetails = " ";
    if (props.templateData == EPRESCRIPTION) {
      notesDetails =
        modifyNotes.localMedicalBrand +
        " " +
        " " +
        " " +
        modifyNotes.dose +
        " " +
        modifyNotes.advicetoDispenser +
        " " +
        modifyNotes.instructionstoPatient;
      console.log("prescriptionDetails", notesDetails);
    } else if (props.templateData == DIAGNOSIS) {
      notesDetails = modifyNotes.problemDiagnosis;
      console.log("prescriptionDetails", notesDetails);
    } else if (props.templateData == VITAL_SIGNS) {
      notesDetails =
        "Temperature: " +
        modifyVitalNotes["Temperature"] +
        " Diastolic: " +
        modifyVitalNotes["Diastolic"] +
        " Height/Length: " +
        modifyVitalNotes["Height/Length"] +
        " Pulse Rate :" +
        modifyVitalNotes["Pulse Rate"] +
        " Respiratory Rate:" +
        modifyVitalNotes["Respiratory Rate"] +
        " Systolic: " +
        modifyVitalNotes["Systolic"] +
        " Weight: " +
        modifyVitalNotes["Weight"] +
        " Oxygen Saturation Level: " +
        modifyVitalNotes["Oxygen Saturation Level (SpO₂)"];
      //+'Pulse Rate'+modifyVitalNotes["Pulse Rate"]+'Respiratory Rate'+modifyVitalNotes["Respiratory Rate"]+'Systolic'+modifyVitalNotes["Systolic"]+'Weight'+modifyVitalNotes["Weight"];
      console.log("prescriptionDetails", notesDetails);
    } else if (props.flags == "editComposition") {
      notesDetails = !props.selectedTests
        ? props.selectedProcedure?.notes
        : `${props.selectedTests} Report`;
    } else {
      notesDetails = "Report";
    }
    let ptehrId = patientEhrid ?? props.patientInfo?.ehrid ?? null;
    const procedure = props.selectedProcedure ?? null;

    if (procedure) {
      procedure.billDate = sampleDateTime;
    }

    const cleanedProcedure = procedure
      ? {
        ...procedure,
        combinedProcedures: (procedure.combinedProcedures || []).map((p) => ({
          id: p.id,
          patientId: p.patientId,
          visitId: p.visitId,
          notes: p.notes,
        })),
      }
      : {
        billDate: sampleDateTime,
        combinedProcedures: [],
      };

    // Non-EHR organisations (for example, Vedamaayu) do not have a patient
    // EHR ID. Still call the backend so it can persist the composition JSON in
    // the local procedures table when the organisation has ehrRequired=false.
    // For EHR-enabled organisations, the backend continues to use ptehrId to
    // create/update the composition in EHRbase.
    if (!ptehrId || ptehrId === "") {
      console.log("Non-EHR org: saving composition in local procedures table");
      ptehrId = "";
    }

    dispatch(
      ehrActions.saveComposition(
        data,
        patientId,
        visitId,
        templateId,
        ptehrId,
        notesDetails,
        cleanedProcedure,
        (resCb) => {
          if (resCb) {
            console.log("Diagnosis Master API Response:", resCb);
            // setSelectedPatientInfo(resCb)
            console.log("forjjfnjgjgi", flag);
            if (resCb.successMessages) {
              if (props.selectedTests) {
                dispatch(
                  patientActions.ValidateShortDesc(
                    cleanedProcedure.id,
                    patientId,
                    visitId,
                    cleanedProcedure.notes,
                    props.selectedTests,
                    (resCb) => {
                      if (resCb) {
                        console.log("Diagnosis Master API Response:", resCb);
                      }
                    }
                  )
                );
              }
              if (flag == undefined && flag != "add new") {
                props.onModalClose({ success: resCb.successMessages[0] });
              }
            } else {
              if (resCb) {
                console.log("resCb  ::: ", resCb);
                if (flag == undefined && flag != "add new") {
                  let msg = templateId + " save failed";
                  console.log("msg  ::: ", msg);
                  props.onModalClose({ error: msg });
                }
              }
            }
          }
        }
      )
    );
  };

  const presSubmit = (event) => {
    props.onModalClose(event);
  };

  const productChange = (event) => {
    //  console.log("change values",event);
    console.log("change values", event.target.value);

    let searchKeyWord = event.target.value;
    setProductDetails(searchKeyWord);

    console.log("productkeyword:", productDetails);
    if (searchKeyWord && searchKeyWord.length > 2) {
      dispatch(
        doctorActions.getProductDetails(
          searchKeyWord,
          PRODUCT_PHARMACY_LOCATION,
          (productResponse) => {
            if (productResponse) {
              console.log(
                "Response of searched product",
                productResponse.erpProductList
              );
              setProductList([...productResponse.erpProductList]);
            }
          }
        )
      );
    } else {
      console.log("enters the else statement");
      setProductList([]);
    }
    // event.preventDefault();
    // event.stopPropagation();
    console.log("onDragOver:", event);
  };

  const selectProduct = (product) => {
    console.log("selectProduct", product);
    let productName = product.name;
    //product.preventDefault();
    setProductDetails(productName);
    console.log("productdetails: ", productDetails);
    setProductList("");
    formErrors.name = "";
    setFormErrors(formErrors);

    // setSelectedProduct(product);
  };

  const icd10Change = (event) => {
    //  console.log("change values",event);
    console.log("icd10changevalues", event.target.value);
    console.log("hhdcj", icd10);
    let searchKeyWord = event.target.value;
    setSelectedIcdDescription(searchKeyWord);
    if (searchKeyWord && searchKeyWord.length >= 1) {
      const filtered = icd10.filter((icd) =>
        icd.description.toLowerCase().startsWith(searchKeyWord.toLowerCase())
      );
      setFilterdIcd10(filtered);
      console.log("filteredIcd10", filteredIcd10);
    }
  };

  const selctedIcd = (icd) => {
    console.log("selectProduct", icd);
    let icdName = icd.description;
    setSelectedIcdDescription(icdName);
    setFilterdIcd10(" ");
    formErrors.name = "";
    setFormErrors(formErrors);
  };

  // const memoizedSchema = useMemo(() => formschema, [formschema]);
  // const memoizedUiSchema = useMemo(() => uiSchema, [uiSchema]);

  // const { schema, uischema} = props;
  // const memoizedForm = useMemo(() => (
  //   <JSONSchemaForm schema={schema} uiSchema={uischema} />
  //  ), [schema, uiSchema]);

  //  return memoizedForm;
  const handleDispatch = (e) => {
    e.preventDefault();
    userName = JSON.parse(localStorage.getItem("user"));
    let data = {};
    let docId = selectedDoctorList?.gvid ? selectedDoctorList.gvid : null;
    setOpen(true);
    // dispatch(
    //   labActions.updateApprover(
    //     data,
    //     userName,
    //     props.selectedProcedure.id,
    //     docId,
    //     (rescb) => {
    //       if (rescb && rescb.successMessages) {
    //         if (docId) {
    //           dispatch(
    //             labActions.createLabReportPDF(
    //               props.selectedProcedure.id,
    //               (rescb) => {
    //                 if (rescb && rescb.successMessages) {
    //                   console.log("PDF created successfully:", rescb);
    //                 } else {
    //                   console.error("Error creating PDF:", rescb);
    //                 }
    //               }
    //             )
    //           );
    //         }

    //         props.onModalClose({ success: "Report Dispatched  successfully" });
    //       } else {
    //         props.onModalClose({ error: "Report Dispatched Failed" });
    //       }
    //     }
    //   )
    // );
  };

  const handleValidate = (e) => {
    e.preventDefault();
    userName = JSON.parse(localStorage.getItem("user"));
    setOpen(true);
    setValidate(true);
  };

  const handleClose = () => {
    setOpen(false);
    setErrorMsg("");
    setUsername("");
    setPassword("");
  };

  const closeAlert = (e) => {
    setServerRes({ ..."" });
  };

  const setMessageStrip = (e) => {
    var ServerResVal = ServerRes;
    if (e.successMessages) {
      ServerResVal.success = e.successMessages;
    } else {
      ServerResVal.error = e.errorMessages;
    }
    setServerRes({ ...ServerResVal });
    setTimeout(() => {
      closeAlert();
      setUsername("");
      setPassword("");
      setErrorMsg("");
    }, 3000);
  };

  const handleValidateSubmit = () => {
    setErrorMsg("");
    let docId = selectedDoctorList?.gvid ? selectedDoctorList.gvid : null;
    let data = {};
    dispatch(
      labActions.logInCheck(username, password, (rescb) => {
        if (rescb && rescb.success) {
          // login success → close popup and dispatch updateApprover
          setOpen(false);
          var ServerResVal = ServerRes;
          if (validate === false) {
            dispatch(
              labActions.updateApprover(
                data,
                username,
                props.selectedProcedure.id,
                docId,
                (rescb2) => {
                  setMessageStrip(rescb2);
                }
              )
            );
          } else {
            dispatch(
              labActions.updateValidator(
                data,
                username,
                props.selectedProcedure.id,
                (rescb2) => {
                  setMessageStrip(rescb2);
                }
              )
            );
          }
        } else if (rescb && rescb.error) {
          // login failed → show error message inside popup
          setErrorMsg("Username or password is incorrect");
        } else {
          setErrorMsg("Something went wrong, please try again");
        }
      })
    );
  };

  const editProcedure = (procedure) => {
    dispatch(
      patientActions.editProcedure(procedure, (rescb) => {
        console.log("Procedure edited successfully:", rescb);
        if (rescb && rescb.successMessages) {
          console.log("Procedure edited successfully:", rescb);
        } else {
          console.error("Error editing procedure:", rescb);
        }
      })
    );
  };

  const handleSubmit = (e) => {
    if (cFollowup != null || dFollowup != null) {
      var proList = {};
      var note = dFollowup != "" ? (note = dFollowup) : (note = cFollowup);
      if (props.mode == "edit")
        proList = {
          id: props.selectedProcedure.id,
          templateId: templateId,
          notes: note,
          patientId: props.selectedProcedure.patientId,
          visitId: props.selectedProcedure.visitId,
        };

      if (props.mode == "new")
        proList = {
          id: id,
          templateId: templateId,
          notes: note,
          patientId: props.patientData[0].patientId,
          visitId: props.patientData[0].visitId,
        };
    }
    dispatch(
      doctorActions.addFollowupNotes(proList, (resCb) => {
        if (resCb) {
          console.log("resCb doctor Response:", resCb);
          if (resCb.successMessages) {
            props.onModalClose({ success: "Notes added successfully" });
          } else {
            props.onModalClose({ error: "Failed to add notes" });
          }
          console.log("resCbe : ", resCb);
        }
      })
    );
  };

  const getDoctorsList = () => {
    const resCb = personDetailsService.getDoctorsDetail();
    if (!resCb) return;
    console.log("resCb doctor Response:", resCb);
    let list = resCb
      .filter((doc) => doc != null)
      .map((doc) => {
        let opt = {
          id: doc.personId,
          gvid: doc.gvId,
          role: doc.role,
          type: doc.type,
          value: doc.email,
          department: doc.department,
          firstName: doc.first_name || "",
          lastName: doc.last_name || "",
          departmentId: doc.departmentId,
          label:
            doc.displaytitle +
            ". " +
            helperServices.getFullName(doc.first_name, null, doc.last_name) +
            ", Dep of " +
            doc.department +
            " (" +
            doc.qualification +
            " )",
        };
        return opt;
      });

    // Filter by type if needed
    if (props.type) {
      list = list.filter(
        (item) => item.type?.toLowerCase() === props.type?.toLowerCase()
      );
    }

    setdoctorList(list);

    // Preselect doctor
    const gvid = props?.selectedProcedure?.refGvId;
    if (gvid) {
      const selected = list.find((item) => item.gvid === gvid);
      if (selected) {
        setSelectedDoctorList(selected);
        setSelectedDoctor(selected.label);
      }
      console.log("Selected Doctor:", selected);
    }
    console.log("Doctor List:", doctorList, list);
  };

  const handleDeptChange = (event) => {
    console.log("Selected Doctor:", event, selectedDoctorList);
    if (event) {
      setSelectedDoctor(event.label);
      setSelectedDoctorList(event);
    } else {
      setSelectedDoctorList([]);
      setSelectedDoctor(null);
    }
  };

  return (
    <>
      <div className="alert-container">
        {ServerRes.success && (
          <Alert severity="success" className="alert-toast alert-toast-paper">
            {ServerRes.success}
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={(event) => closeAlert(event)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Alert>
        )}

        {ServerRes.error && (
          <Alert severity="error" className="alert-toast alert-toast-paper">
            {ServerRes.error}
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={(event) => closeAlert(event)}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </Alert>
        )}
      </div>

      <div>
        <div>
          <List
            component="nav"
            aria-label="main mailbox folders"
            className={
              props.mode === "edit" &&
                props.selectedProcedure?.subgroup !== "Lab_Report"
                ? "hide-submit"
                : "template-form"
            }
          >
            <ListItem className="d-block py-0 px-0 bg-none">
              <div className="mt-2 shadow service-list-container">
                {productList &&
                  productList.length > 0 &&
                  productList.map((product, index) => (
                    <Paper
                      key={index}
                      className="border-bottom blog-comments__item d-flex p-2 cpointer flex-wrap border-0 flex-column"
                      onClick={(event) => selectProduct(product, index)}
                    >
                      <Typography variant="subtitle1" color="textSecondary">
                        {product.name}
                      </Typography>
                    </Paper>
                  ))}
              </div>

              {(templateId === DIAGNOSIS ||
                selectProcedureTemplateId === DIAGNOSIS) && (
                  <>
                    {props.mode === "edit" &&
                      selectProcedureTemplateId === DIAGNOSIS && (
                        <Grid container style={{ marginBottom: "10px" }}>
                          {/*<Grid item sm={12} md={6}>
            <Typography variant="body1" className="brand">
              Problem/Diagnosis name
            </Typography>
            <TextField className="templateSearch"
            fullWidth
              value={compositionPreviewValue.icdName}
              readOnly
            />
          </Grid>*/}
                        </Grid>
                      )}

                    {(props.mode === "new" || templateId === DIAGNOSIS) && (
                      <Grid container style={{ marginBottom: "10px" }}>
                        {/* <Grid item sm={12} md={6}>
          <Typography variant="body1" className="brand">
            Problem/Diagnosis name
          </Typography>
          <TextField className="templateSearch"
          fullWidth
            value={selectedIcdDescription}
            placeholder="Select the Problem/Diagnosis name"
            required
            autoComplete="off"
            onChange={icd10Change}
            error={formErrors.name !== ""}
            helperText={formErrors.name}
          />
        </Grid> */}
                      </Grid>
                    )}
                  </>
                )}

              {(selectProcedureTemplateId == DFollowupNote ||
                templateId == DFollowupNote) && (
                  <>
                    <Box py={3} pl={0} width="100%">
                      <label className="brand">Doctor's Followup Notes</label>
                      <TextField
                        fullWidth
                        multiline
                        className="p-2"
                        value={dFollowup}
                        placeholder="Followup Notes"
                        autoComplete="off"
                        type="text"
                        onChange={(event) => setDFollowup(event.target.value)}
                      />
                    </Box>
                    <Box p={3} width="100%" textAlign="right">
                      <Button
                        variant="contained"
                        color="primary"
                        className="p-2 border rounded"
                        onClick={(e) => handleSubmit(e)}
                      >
                        Save
                      </Button>
                    </Box>
                  </>
                )}

              {(selectProcedureTemplateId == CFollowupNote ||
                templateId == CFollowupNote) && (
                  <>
                    <Box py={3} pl={0} width="100%">
                      <label className="brand">Counsellor's Followup Notes</label>
                      <TextField
                        fullWidth
                        multiline
                        className="p-2"
                        value={cFollowup}
                        placeholder="Followup Notes"
                        autoComplete="off"
                        type="text"
                        onChange={(event) => setCFollowup(event.target.value)}
                      />
                    </Box>
                    <Box p={3} width="100%" textAlign="right">
                      <Button
                        variant="contained"
                        color="primary"
                        className="p-2 border rounded"
                        onClick={(e) => handleSubmit(e)}
                      >
                        Save
                      </Button>
                    </Box>
                  </>
                )}
              {selectProcedureTemplateId !== DFollowupNote &&
                templateId !== DFollowupNote &&
                selectProcedureTemplateId !== CFollowupNote &&
                templateId !== CFollowupNote && (
                  <div>
                    <Grid container>
                      <Grid item md="12" lg="12" className="px-0">
                        {formschema ? (
                          templateId === EPRESCRIPTION ||
                            selectProcedureTemplateId === EPRESCRIPTION ? (
                            <div className="">
                              <Components.Prescription
                                schema={formschema}
                                data={presData}
                                mode={props.mode}
                                patientId={patientId}
                                patientInfo={props.patientInfo}
                                visitId={visitId}
                                form={eprescription}
                                onModalClose={(event) => presSubmit(event)}
                              />
                            </div>
                          ) : props.mode === "new" ||
                            templateId === DIAGNOSIS ? (
                            <>
                              {showError && (
                                <div className="text-danger my-4">
                                  All fields can not be empty!
                                </div>
                              )}
                              <JSONSchemaForm
                                schema={formschema}
                                uiSchema={uiSchema}
                                formData={newformData}
                                formContext={formContext}
                                onChange={onChanges}
                                onSubmit={onFormSubmit}
                              />
                            </>
                          ) : props.selectedProcedure?.subgroup ===
                            "Lab_Report" ? (
                            <>
                              {showError && (
                                <div className="text-danger my-4">
                                  All fields can not be empty!
                                </div>
                              )}
                              {props.role === "LabAdmin" && (
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginBottom: "1rem",
                                    gap: "10px", // space between select and button
                                  }}
                                  className="mx-2"
                                >
                                  {(!props.selectedProcedure.approver ||
                                    (props.selectedProcedure.approver &&
                                      selectedDoctor)) && (
                                      <Select
                                        name="Search Doctor"
                                        className="w-25"
                                        placeholder="Select Doctor"
                                        isClearable
                                        isSearchable
                                        isDisabled={
                                          !!props.selectedProcedure.approver
                                        }
                                        options={doctorList}
                                        value={
                                          doctorList?.find(
                                            (option) =>
                                              option.label === selectedDoctor
                                          ) || null
                                        }
                                        onChange={handleDeptChange}
                                      />
                                    )}
                                  <Button
                                    variant="outlined"
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "#3f51b5",
                                      borderColor: "#3f51b5",
                                    }}
                                    onClick={(e) => handleDispatch(e)}
                                  >
                                    {props.selectedProcedure.approver
                                      ? "Re-Verify"
                                      : "Verify"}
                                  </Button>
                                  <Button
                                    variant="outlined"
                                    style={{
                                      backgroundColor: "transparent",
                                      color: "#3f51b5",
                                      borderColor: "#3f51b5",
                                    }}
                                    onClick={(e) => handleValidate(e)}
                                  >
                                    ValiDate
                                  </Button>
                                  <Dialog open={open} onClose={handleClose}>
                                    <DialogTitle>Enter Credentials</DialogTitle>
                                    <form
                                      onSubmit={(e) => {
                                        e.preventDefault(); // prevent page refresh
                                        handleValidateSubmit(); // call your submit handler
                                      }}
                                    >
                                      <DialogContent>
                                        <TextField
                                          autoFocus
                                          margin="dense"
                                          label="Username"
                                          type="text"
                                          fullWidth
                                          value={username}
                                          onChange={(e) =>
                                            setUsername(e.target.value)
                                          }
                                          error={Boolean(errorMsg)}
                                          variant="standard"
                                        />
                                        <TextField
                                          margin="dense"
                                          label="Password"
                                          type="password"
                                          fullWidth
                                          value={password}
                                          onChange={(e) =>
                                            setPassword(e.target.value)
                                          }
                                          error={Boolean(errorMsg)}
                                          helperText={errorMsg}
                                          variant="standard"
                                        />
                                      </DialogContent>
                                      <DialogActions>
                                        <Button
                                          onClick={handleClose}
                                          color="secondary"
                                        >
                                          Cancel
                                        </Button>
                                        <Button type="submit" color="primary">
                                          Submit
                                        </Button>
                                      </DialogActions>
                                    </form>
                                  </Dialog>
                                </div>
                              )}
                              <JSONSchemaForm
                                schema={formschema}
                                uiSchema={uiSchema}
                                formData={newformData}
                                formContext={formContext}
                                onChange={onChanges}
                                onSubmit={onFormSubmit}
                                disabled={props.role !== "LabAdmin"}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-start", // align left
                                  alignItems: "center",
                                  marginTop: "80px", // push it a little lower
                                  marginLeft: "10px", // optional padding from left
                                  gap: "10px",
                                }}
                              >
                                <label htmlFor="sampleDateTime">
                                  Sample Received Date & Time:
                                </label>
                                <input
                                  type="datetime-local"
                                  id="sampleDateTime"
                                  name="sampleDateTime"
                                  value={formatDateTimeLocal(sampleDateTime)}
                                  onChange={(e) =>
                                    setSampleDateTime(e.target.value)
                                  }
                                />
                              </div>
                            </>
                          ) : (
                            <JSONSchemaForm
                              schema={formschema}
                              uiSchema={uiSchema}
                              onSubmit={onFormSubmit}
                              onChange={onChanges}
                            />
                          )
                        ) : (
                          ""
                        )}
                      </Grid>
                    </Grid>
                  </div>
                )}
            </ListItem>
          </List>
        </div>
      </div>
    </>
  );
}
export default PatientSchema;
// export default React.memo(PatientSchema);
